export default __webpack_public_path__ + "static/media/ban-mobile-image-1.4b80383a.jpg";